export default __webpack_public_path__ + "static/media/brand_02.b1369b60.png";